import React from 'react';
import { Col, Row } from 'antd';
import { RankChart } from '../RankChart';

const IncidentReportSection = ({ data, topCameraData, topGatewayData }) => {
  if (!data?.cameraDisconnectionEvent && !data?.gatewayDisconnectionEvent) {
    return null;
  }

  return (
    <div>
      <div className="section-title">THỐNG KÊ THEO SỐ LƯỢNG SỰ CỐ</div>
      <Row gutter={8} style={{ marginTop: 10 }}>
        <Col span={12} style={{ alignSelf: 'stretch' }}>
          <div
            className="content-center chart-item"
            style={{ height: '100%' }}
          >
            <div className="chart-title">Top cameras disconnected</div>
            <RankChart color="#FFC94A" data={topCameraData} />
          </div>
        </Col>
        <Col span={12}>
          <div className="content-center chart-item">
            <div className="chart-title">Top gateways disconnected</div>
            <RankChart color="#FFC94A" data={topGatewayData} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default IncidentReportSection;
